import { render, staticRenderFns } from "./NavbarPreorder.vue?vue&type=template&id=6b329a12"
import script from "./NavbarPreorder.vue?vue&type=script&lang=js"
export * from "./NavbarPreorder.vue?vue&type=script&lang=js"
import style0 from "./NavbarPreorder.vue?vue&type=style&index=0&id=6b329a12&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports